export {}

const gallery = document.querySelectorAll<HTMLElement>(".s-faq, .s-gallery-intro")

gallery.forEach((section) => {
  const gallerySlider = section.querySelector<HTMLElement>(".g-gallery-slider__large-img .g-gallery-slider")
  const gallerySlidersOverview = section.querySelector<HTMLElement>(".g-gallery-slider__wrapper .g-gallery-slider")

  if (!gallerySlider || !gallerySlidersOverview) return

  const largeImages = section.querySelectorAll(".g-gallery-slider__large-img button")

  largeImages.forEach((img) => {
    img.addEventListener("click", () => {
      const galleryLg = img.closest(".g-gallery-slider__large-img")
      const galleryLgActiveItem = img.closest(".swiper-slide")
      const gallery = galleryLg?.closest("section")?.querySelector<HTMLElement>(".g-gallery-slider__wrapper .g-gallery-slider")

      if (!gallery) return

      const galleryItems = Array.from(gallery?.querySelectorAll(".swiper-slide"))

      const selector = galleryLgActiveItem?.getAttribute("data-index")
      const slideActive = galleryItems[Number(`${selector}`)]
      const imgActive = slideActive.querySelector<HTMLElement>("a")

      imgActive?.click()
    })
  })
})
